export default {
  ru: {
    message: {
      addressRegion: 'Россия, Алтайский край,',
      addressStreet: 'Барнаул, пр.Космонавтов, 32ж/1',
      calculatingPeriod: 'Расчетный период',
      calculationOfProfitability: 'Расчет рентабельности производства газобетона на линии {line} за {period} при загруженности в {capability} в сутки',
      profitabilityCalculationOf: 'Расчет рентабельности линии',
      capability: 'Производительность',
      component: 'Компонент',
      copyright: '© АлтайСтройМаш, 2000-{year}',
      cost: 'Стоимость',
      costPrice: 'Себестоимость',
      costPriceOf: 'Себестоимость {0} газобетона',
      currency: 'Валюта',
      day: 'сутки',
      electricity: 'Электроэнергия',
      for1CubicMeter: 'На 1 м³ газобетона',
      forPeriodOf: 'На {period}',
      goToDescription: 'Перейти к описанию линии',
      needsFor: 'Потребность на {period}',
      international: 'Международный',
      pieceRate: 'Зарплата',
      price: 'Цена',
      profit: 'Прибыль',
      profitabilityBasedOn: 'Рентабельность из расчета на {0} м³',
      profitabilityOfAerocreteProduction: 'Рентабельность производства газобетона',
      quantity: 'Количество',
      rent: 'Аренда',
      sellPrice: 'Цена продажи',
      site: 'Сайт',
      spendsBasedOn: 'Затраты из расчета на {0} м³ газобетона',
      spendsFor: 'Затраты на {period}',
      spendsTo: 'Затраты на {thing}',
      sum: 'Сумма',
      totalSpendsForSalary: 'Суммарные затраты на заработную плату на производство',
      volumeOfProduction: 'Объем производства',
      helpHeader: 'Учитываем себестоимость газоблока и другие факторы',
      helpText: 'Калькулятор рентабельности позволяет рассчитать сроки окупаемости оборудования в зависимости от цен на сырье, себестоимости газобетона (1 куб), стоимости аренды, зарплаты рабочим и других факторов. Вы можете самостоятельно регулировать исходные данные и наблюдать, как меняются результаты.',
      helpHeader1: 'Какую стоимость газобетона вам установить?',
      helpText1: 'Как посчитать прибыль от продажи газобетона? И через сколько окупится именно ваша производственная линия? Воспользуйтесь нашим калькулятором, чтобы посчитать рентабельность бизнеса. Также калькулятор поможет вам в ценообразовании: вы можете рассчитать стоимость газобетона собственного производства для достижения успеха на рынке.',

    },
    plural: {
      day: '0 дней | {n} день | {n} дня | {n} дней',
      dayShort: 'дней | день | дня | дней',
      m2: '{n} м²',
      m3: '{n} м³'
    },
    measure: {
      kW: 'кВт',
      m2: 'м²',
      m3: 'м³',
      Nm2: '{0} м²',
      Nm3: '{0} м³'
    }
  },
  en: {
    message: {
      addressRegion: 'Russia, Altai region,',
      addressStreet: 'Barnaul, Cosmonavtov avenue, 32j/1',
      calculatingPeriod: 'Calculating period',
      calculationOfProfitability: 'Calculation of profitability of aerocrete blocks production on the line {line} for {period} when the line is loaded at {capability} per day',
      profitabilityCalculationOf: 'Profitability calculation of',
      capability: 'Capability',
      component: 'Component',
      copyright: '© ASM-GROUP ltd, 2000-{year}',
      cost: 'Cost',
      costPrice: 'Cost price',
      costPriceOf: 'Cost price of {0} aerocrete',
      currency: 'Currency',
      day: 'day',
      electricity: 'Electricity fee',
      for1CubicMeter: 'For 1 m³ of aerocrete',
      forPeriodOf: 'For {period}',
      goToDescription: 'Go to description of the line',
      needsFor: 'Consumables for {period}',
      international: 'International',
      pieceRate: 'Piece rate',
      price: 'Price',
      profit: 'Profit',
      profitabilityBasedOn: 'Profitability based on {0} m³',
      profitabilityOfAerocreteProduction: 'Profitability of aerocrete blocks production',
      quantity: 'Quantity',
      rent: 'Rent',
      sellPrice: 'Selling price',
      site: 'Site',
      spendsBasedOn: 'Spends based on {0} m³ of aerocrete',
      spendsFor: 'Spends for {period}',
      spendsTo: 'Spends to {thing}',
      sum: 'Sum',
      totalSpendsForSalary: 'Total spends on salary for produce',
      volumeOfProduction: 'Volume of production',
      helpHeader: 'Take into account the cost price and all other factors',
      helpText: 'The profitability calculator gives you an opportunity to calculate the payback period of equipment depending on raw material prices, the cost price of 1 m³ of aerocrete, rent price, labor cost, and other factors. You can control input values and see how the result changes.',
      helpHeader1: 'What selling price of aerocrete shall I set?',
      helpText1: `How to earn profit from selling aerocrete, and how soon your production line will give a payback?
                  Use our calculator to calculate the profitability of your business.
                  Also, the calculator helps you make a decision about the final price of your production to gain success in the market
      `,

    },
    plural: {
      day: '0 days | {n} day | {n} days',
      dayShort: 'days | day | days',
      m2: '{0} m²',
      m3: '{0} m³'
    },
    measure: {
      kW: 'kW',
      m2: 'm²',
      m3: 'm³',
      Nm2: '{0}m²',
      Nm3: '{0}m³'
    }
  }
}
